export default __webpack_public_path__ + "static/media/pic2.f9822b64.jpg";